/*
 * ONNE - Fix "primer tap no navega" en movil/tactil para cards dentro de carrusel.
 * Fecha: 2026-06-06 (v4: + product-card-onne)
 * Causa: en iOS, ciertas cards (collection-card con link overlay hermano; y
 * product-card-onne dentro de slideshow horizontal) no navegan al primer tap y
 * exigen 2 toques. Los grids/PDP funcionan bien y no necesitan esto.
 * Fix: en tactil, navegamos directo en 'touchend' tras un tap LIMPIO (sin
 * desplazamiento = no es swipe). Respetamos swatches/botones/enlaces anidados
 * (no se secuestran: el swatch sigue cambiando color, etc.). Bypassa la
 * heuristica de iOS sin tocar desktop.
 * Revertir: quitar el <script> de layout/theme.liquid y borrar este asset.
 */
(function () {
  if (!window.matchMedia || !matchMedia('(hover: none)').matches) return;
  var sx = 0, sy = 0, moved = false, MOVE = 10;
  // Elementos que NO debemos secuestrar (manejan su propia interaccion)
  var GUARD = '.product-card-onne__color-swatch, .swatch, button, [role="button"], input, label, select, ' +
              '.collection-card__inner a[href], .collection-card__inner button';

  addEventListener('touchstart', function (e) {
    var t = e.changedTouches[0]; if (!t) return; sx = t.clientX; sy = t.clientY; moved = false;
  }, { passive: true, capture: true });

  addEventListener('touchmove', function (e) {
    var t = e.changedTouches[0]; if (!t) return;
    if (Math.abs(t.clientX - sx) > MOVE || Math.abs(t.clientY - sy) > MOVE) moved = true;
  }, { passive: true, capture: true });

  addEventListener('touchend', function (e) {
    if (moved) return;                                   // fue swipe del carrusel
    var t = e.changedTouches[0]; if (!t) return;
    var el = document.elementFromPoint(t.clientX, t.clientY);
    if (!el || !el.closest) return;
    var card = el.closest('.collection-card, .product-card-onne, .product-card');
    if (!card) return;
    if (el.closest(GUARD)) return;                       // swatch/boton/enlace anidado -> que lo maneje el
    var link = card.querySelector(
      'a.collection-card__link[href], a.product-card-onne__link[href], a.product-card__link[href]'
    );
    if (!link) return;
    var href = link.getAttribute('href');
    if (!href) return;
    window.location.href = href;
  }, { passive: true, capture: true });
})();
